import React from 'react';
import './ViewSwitch.css';

/* Bascule de VUE d'un rapport — Réel / Prévisionnel (Budget à venir avec la
   dimension version). La vue est une dimension du rapport, pas une section du
   menu : un même état financier se lit sous plusieurs angles sans changer
   d'écran. Même emplacement que la bascule d'unité, dans l'ancre droite des
   onglets.

   Props : options = [{ id, label }] · value · onChange(id). */
export default function ViewSwitch({ options, value, onChange, ariaLabel }) {
  return (
    <div className="view-switch" role="group" aria-label={ariaLabel}>
      {options.map((o) => (
        <button
          key={o.id}
          type="button"
          className={`view-switch__seg${o.id === value ? ' on' : ''}`}
          aria-pressed={o.id === value}
          onClick={() => onChange(o.id)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
